export const mountPrefix = (pathname, subFolder) => {
    if (!pathname || !subFolder) {
        return "";
    }

    const nested = pathname.indexOf(`${subFolder}/`);
    const exact = pathname.endsWith(subFolder) ? pathname.length - subFolder.length : -1;
    const start = nested >= 0 ? nested : exact;

    return start > 0 ? pathname.slice(0, start) : "";
};

const segmentEnd = (pathname, segment) => {
    if (!pathname || !segment) {
        return -1;
    }

    const match = new RegExp(`(?:^|/)${segment}(?:/|$)`).exec(pathname);

    return match ? match.index + match[0].indexOf(segment) + segment.length : -1;
};

export const hubBasePath = (pathname, subFolder, clientId) => {
    const mountedAt = segmentEnd(pathname, clientId ? String(clientId) : "");

    if (mountedAt > 0) {
        return pathname.slice(0, mountedAt);
    }

    return `${mountPrefix(pathname, subFolder)}${subFolder || ""}`;
};
